import Dexie, { type Table } from "dexie";

import type { IndexedTemplateSyncUpdateValue, TemplateIndexTuple } from "@/store/templates/types";

export async function getRecentTemplateIndexTuples(
  localTable: Table<IndexedTemplateSyncUpdateValue>,
  limit: number
): Promise<TemplateIndexTuple[]> {
  const indexTuples = await localTable
    .where("[last_used_at+model_id]")
    .aboveOrEqual(["\0", Dexie.minKey])
    .reverse()
    .filter(template => !template.model_data.is_default_calendar_event_template)
    .limit(limit)
    .keys();

  return indexTuples as unknown as TemplateIndexTuple[];
}
